
import getArea from '../state/get-area';

export default (function (el) {
  return getArea(el.getBoundingClientRect()).center;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-beautiful-dnd/esm/view/get-center-position.js
// module id = 495
// module chunks = 0